module.exports = __webpack_public_path__ + "static/media/rank-no-3.564eb1c6.svg";